import React, { useState, useEffect } from 'react';
import AuthenticationButtons from '../components/AuthenticationButtons.js';
import logo from '../media/logo.png';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, loggedIn } from '../utils/firebase.js';
import accountIcon from '../media/accountIcon.png';
import { useCookieConsentStore } from '../stores/useCookieConsentStore.js';
import { acceptTerms } from '../data/users.js';
import { toggleModal } from '../utils/uiUtils.js';
import { useAuthStore } from '../stores/useAuthStore.js';
import { useNavigate } from 'react-router-dom';

function SiteNav(props) {
    const [isLoggedIn, setIsLoggedIn] = useState((auth.currentUser ? true : false));
    const [isTermsChecked, setIsTermsChecked] = useState(false);
    const mustAgreeToTerms = useAuthStore((state) => state.mustAgreeToTerms);
    const navigate = useNavigate();

    useEffect(() => {
        onAuthStateChanged(auth, (user) => {
            if (user) {
                setIsLoggedIn(true);
            } else {
                setIsLoggedIn(false);
            }
        })
    }, []);

    useEffect(() => {
        const exemptPage = ["/privacy", "/termsAndConditions"].indexOf(window.location.pathname) !== -1;
        if (!exemptPage && isLoggedIn && mustAgreeToTerms) {
            toggleModal("modal-newPrivacy");
        }
    }, [isLoggedIn, mustAgreeToTerms])

    const toggleMenu = () => {
        document.getElementById("bgsNavbar").classList.toggle('is-active');
        document.getElementById("bgsBurgerMenu").classList.toggle('is-active');
    }

    const handleAcceptTerms = async () => {
        await acceptTerms();
        toggleModal("modal-newPrivacy");
    }

    return (
        <>
            <section className="">
                <div className="navbar is-fixed-top has-background-primary" role="navigation" aria-label="main navigation">
                    <div className="navbar-brand">
                        <a href={(loggedIn() ? "/trackingList" : "/")}>
                            <img className="image ml-4 mt-4 mb-2" alt="Board Game Tally Logo" src={logo} ></img>
                        </a>
                        <a className="navbar-burger has-text-white" id="bgsBurgerMenu" role="button" aria-label="menu" aria-expanded="false" onClick={toggleMenu} >
                            <span aria-hidden="true"></span>
                            <span aria-hidden="true"></span>
                            <span aria-hidden="true"></span>
                            <span aria-hidden="true"></span>
                        </a>
                    </div>
                    <div className="navbar-menu" id="bgsNavbar">
                        <div className="navbar-end mr-2">
                            {isLoggedIn &&
                                <>
                                    <div className="navbar-item">
                                        <div className='navbar-item is-hidden-touch'>
                                            <button
                                                className="button is-rounded is-white"
                                                style={{ padding: 0, width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                                onClick={() => { navigate('/manageAccount') }} >
                                                <img
                                                    src={accountIcon}
                                                    alt="Account"
                                                    style={{ borderRadius: '50%', width: 32, height: 32, objectFit: 'cover' }}
                                                />
                                            </button>
                                        </div>
                                    </div>
                                </>
                            }
                            <div className="navbar-item has-dropdown mr-5" id="toggleAboutUs">
                                <a className="navbar-link has-text-light" onClick={() => { document.getElementById("toggleAboutUs").classList.toggle("is-active") }}> About Us </a>
                                <div className="navbar-dropdown is-boxed">
                                    <a className="navbar-item" href="/whatsNew">What's New </a>
                                    <a className="navbar-item" onClick={() => { useCookieConsentStore.getState().setShowBanner(true); document.getElementById("toggleAboutUs").classList.toggle("is-active"); }}> Manage Cookies</a>
                                    <a className="navbar-item" href="/privacy"> Privacy Policy </a>
                                    <a className="navbar-item" href="/termsAndConditions"> Terms & Conditions </a>
                                    <a className="navbar-item" href="/contactForm">Contact </a>
                                </div>
                            </div>
                            {isLoggedIn &&
                                <>
                                    <div className='navbar-item is-hidden-desktop'>
                                        <a className="has-text-light" href="/manageAccount"> Manage Account </a>
                                    </div>
                                    <div className='navbar-item'>
                                        <AuthenticationButtons />
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </section >

            <div id="modal-newPrivacy" className="modal">
                <div className="modal-background"></div>
                <div className="modal-card">
                    <header className="modal-card-head">
                        <p className="modal-card-title">We've Updated Our Policies</p>
                    </header>
                    <section className="modal-card-body">
                        <div className="mb-4">
                            <h5 className="title is-5 mb-0">Sorry to interrupt</h5>
                            <span className="is-size-6">
                                We recently overhauled our Privacy Policy and Terms and Conditions. To continue using Board Game Tally, you must
                                review and agree to the new <strong>Terms and Conditions</strong> and acknowledge our <strong>Privacy Policy</strong>.
                            </span>
                            <div className="has-text-centered mt-5">
                                <a href="/privacy" className="is-underlined is-link mr-5" target="_blank">Privacy Policy</a>
                                <a href="/termsAndConditions" className="is-underlined is-link" target="_blank">Terms & Conditions</a>

                            </div>
                        </div>
                        <div className="mb-4">
                            <h5 className="mb-0 title is-5">Why Now?</h5>
                            <span className="is-size-6">
                                <div>
                                    We are a small outfit (1 developer, and I just do this in my spare time). I am trying to make sure I comply with the various laws and policies as best I can. I maintain a privacy first approach
                                    (no advertising, no sharing, no tracking). This privacy policy update maintains those protections.
                                </div>
                                <div className="mt-4">
                                    As part of this update you are now able to <strong>request a copy of your data</strong> and <strong>delete your account and data</strong>. Both of these actions
                                    are available through the <strong>My Account</strong> (Meeple Icon) at the top of the page.
                                </div>
                                <div className="mt-4">
                                    If you do not wish to agree to these policies (and hence do not wish to log in),
                                    but want your data (or to delete your account), please email me and I will help you: privacy@HappyPathDevelopment.com
                                </div>
                            </span>
                        </div>
                        <label className="checkbox p-2" id="termsCheckboxLabel">
                            <input type="checkbox" checked={isTermsChecked} className="mr-2" id="termsCheckbox" onChange={(e) => { setIsTermsChecked(e.target.checked); }} />
                            I have read and agree to the Terms and Conditions and acknowledge the Privacy Policy.
                        </label>
                    </section >
                    <footer className="modal-card-foot">
                        <button className="button is-primary" id="acceptButton" aria-label="close" disabled={!isTermsChecked} onClick={() => { handleAcceptTerms(); }}>I Agree</button>
                    </footer>
                </div>
            </div>
        </>
    );
}

export default SiteNav;